import React from "react"

function NotFound() {
  return <div>You're Lost Buddy</div>
}

export default NotFound
